import React from "react";
import styles from "./atoms.Notification.module.scss";
import Icon from "components/MainApp/atoms/Icon/icon";
import CloseIcon from '@mui/icons-material/Close';

const MainNotification = ({ open, label, type, closeEvent }) => {
  const icon = type === "success" ? "icon-check-circle" : "";
  return (
    <div>
      {open && (
        <div className={`${styles["main-notification-container"]} ${type ? styles[type] : ""}`}>
          <div className={styles["main-notification-content-wrapper"]}>
            {type === "success" && (
              <i className={`${icon} ${styles["main-notification-icon"]}`}></i>
            )}
            {type === "error" && (
              <div className={styles["main-notification-icon"]}>
                <Icon name={"info"} width={30} height={30} fill={"#F55E69"} />
              </div>
            )}
            <p className={styles["main-notification-label"]}>{label}</p>
            <CloseIcon className={styles["main-notification-icon-close"]} onClick={closeEvent}/>
          </div>
        </div>
      )}
    </div>
  );
};

export default MainNotification;
